// Omnix/client/widgets/UnassignedConversationsWidget.js
export default {
    name: "UnassignedConversationsWidget",
        description: "Displays conversations that are still unassigned to users.",

    type: "DataWidget",
    roles: ["manager"],
    widget: {
        title: "Unassigned Queue",
        dataProvider: {
            main: {
                rpc: "ManagerDashboardRpc.getUnassignedConversations",
                transform: (response) => response?.data || []
            }
        },
        // --- FIX: Use enrichData to resolve the contactId to a displayName ---
        async enrichData(data, appClient) {
            if (data.main && data.main.length > 0) {
                const enrichmentPromises = data.main.map(async (convo) => {
                    if (convo.contactId) {
                        const contact = await appClient.rds.get('projectContacts', convo.contactId);
                        convo.contactName = contact ? contact.displayName || `${contact.firstName} ${contact.lastName}` : 'Unknown Contact';
                    } else {
                        convo.contactName = 'Unknown Contact';
                    }
                    return convo;
                });
                data.main = await Promise.all(enrichmentPromises);
            }
            return data;
        },
        itemAction: {
            type: 'navigate',
            route: '/user/inbox?conversationId={{_id}}'
        },
        itemTemplate: (item) => {
            const channelIcons = {
                "voice": "bi-telephone-fill", "sms": "bi-chat-text-fill", "whatsapp": "bi-whatsapp",
                "email": "bi-envelope-fill", "web_chat": "bi-chat-dots-fill", "facebook_messenger": "bi-messenger",
                "instagram": "bi-instagram", "telegram": "bi-telegram"
            };
            const icon = channelIcons[item.channelType] || 'bi-question-circle-fill';
            const snippet = item.lastInteractionSnippet ? item.lastInteractionSnippet.substring(0, 60) + (item.lastInteractionSnippet.length > 60 ? '...' : '') : 'No recent message';

            return `
                <style>
                    .convo-card { padding: 0.75rem; border-left: 4px solid var(--bs-warning); background-color: var(--bs-tertiary-bg); border-radius: var(--bs-border-radius); margin-bottom: 0.5rem; }
                </style>
                <div class="convo-card">
                    <div class="d-flex align-items-center">
                        <div class="fs-4 me-3 text-muted"><i class="bi ${icon}"></i></div>
                        <div class="flex-grow-1">
                            <div class="fw-bold">${item.contactName}</div>
                            <div class="text-muted fst-italic small">${snippet}</div>
                        </div>
                    </div>
                </div>
            `;
        },
        noDataMessage: "The unassigned queue is empty."
    }
};
